import react, { useState, useEffect } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Box,
	Checkbox,
	IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";

const SelectedRow = (props) => {
	const { orderId, patientName, doctorName, orderType, endDate, unitCount } =
		props;
	const dispatch = useDispatch();
	const handleChange = () => {
		dispatch({
			type: "omit",
			payload: {
				orderId,
			},
		});
	};
	return (
		<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
			<TableCell align="justify">{doctorName}</TableCell>
			<TableCell align="justify">{patientName}</TableCell>
			<TableCell align="justify">{orderType}</TableCell>
			<TableCell align="justify">{unitCount}</TableCell>
			<TableCell align="justify">{endDate}</TableCell>
			<TableCell align="justify">
				<IconButton size="small" onClick={handleChange}>
					<DeleteIcon color="secondary" />
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default SelectedRow;
